import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog(props) {
  return (
    <div>
      <Dialog
        open={props.open}
        style={{
          zIndex: 999999999
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div>
          {props.title && (
            <DialogTitle
              id="alert-dialog-title"
              style={{
                fontSize: 15
              }}
            >
              {props.title}
            </DialogTitle>
          )}
          {props.content && (
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {props.content}
              </DialogContentText>
            </DialogContent>
          )}
        </div>

        <DialogActions>
          <Button
            onClick={() => props.noAction()}
            color="primary"
            style={{
              fontSize: 12
            }}
          >
            No
          </Button>
          <Button
            onClick={() => props.yesAction()}
            color="primary"
            autoFocus
            style={{
              fontSize: 12
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
